import { styled } from '@mui/material';
import Divider from 'shell/components/Divider';
import IconButton from 'shell/components/IconButton';
import Stack from 'shell/components/Stack';
import Text from 'shell/components/Text';

const FileViewerControls = ({ currentPage, numPages, scale, setScale, hidden, setHidden }) => {
    return (
        <ControlsStack
            alignItems={'center'}
            direction={'row'}
            divider={<CustomDivider flexItem orientation={'vertical'} />}
            spacing={2}
        >
            <Text>
                Page {currentPage}/{numPages}
            </Text>
            <Stack alignItems={'center'} direction={'row'} spacing={2}>
                <IconButton
                    aria-label={'zoom in'}
                    disabled={scale > 2}
                    kind={'zoomIn'}
                    variant={'square'}
                    size={'medium'}
                    onClick={() => setScale((current) => current + 0.25)}
                />
                <Text>{scale * 100}%</Text>
                <IconButton
                    aria-label={'zoom out'}
                    disabled={scale < 0.75}
                    kind={'zoomOut'}
                    variant={'square'}
                    size={'medium'}
                    onClick={() => setScale((current) => current - 0.25)}
                />
            </Stack>
            <IconButton
                aria-label={'toggle annotations'}
                kind={hidden ? 'hide' : 'visible'}
                variant={'square'}
                size={'medium'}
                onClick={() => setHidden((current) => !current)}
            />
        </ControlsStack>
    );
};

const ControlsStack = styled(Stack)(({ theme }) => {
    return {
        position: 'absolute',
        bottom: '5%',
        left: '50%',
        zIndex: 2,
        borderRadius: '8px',
        width: 'max-content',
        padding: theme.spacing(3),
        background: `${theme.palette.ensightful.neutral[900]}cc`,
        transform: 'translateX(-50%)',
        '& p, button': {
            color: theme.palette.ensightful.neutral[50],
            '&:focus-visible': {
                outlineColor: theme.palette.ensightful.shades[0],
            },
        },
    };
});

const CustomDivider = styled(Divider)(({ theme }) => {
    return {
        borderColor: `${theme.palette.ensightful.shades[0]}4d`,
    };
});

export default FileViewerControls;
